// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
ion-button {
  font-family: "Roboto-Medium";
}

.px-16px {
  padding-left: 16px;
  padding-right: 16px;
}

.py-16px {
  padding-top: 16px;
  padding-bottom: 16px;
}

.p-16px, .modal-content .information {
  padding: 16px;
}

.pr-16px {
  padding-right: 16px !important;
  padding-inline-end: 16px !important;
}

.pl-16px {
  padding-left: 16px !important;
  padding-inline-start: 16px !important;
}

.pb-16px {
  padding-bottom: 16px;
}

.pt-16px {
  padding-top: 16px;
  --padding-top: 16px;
}

.m-0 {
  margin: 0 !important;
}

.p-0 {
  padding: 0 !important;
}

.d-f-a-c, .modal-content .facility .facility-name {
  align-items: center;
  display: flex;
}

.three-dots {
  display: block;
  text-overflow: ellipsis;
  overflow: hidden;
  width: 100%;
  height: 100%;
  white-space: nowrap;
}

.additional-space ::ng-deep.sc-ion-modal-md-h, .additional-space ::ng-deep.sc-ion-modal-ios-h {
  --height: 60%;
  --min-height: 470px;
}

::ng-deep ion-modal.auto-height .modal-wrapper {
  background: white !important;
  max-height: 95vh;
}

.inner-content {
  padding: 0 !important;
  max-height: 90vh !important;
}

.shared-with-me.show-bg {
  background: #FCFEE9;
}
.shared-with-me.show-bg .modal-header, .shared-with-me.show-bg .modal-content {
  background: #FCFEE9;
}
.shared-with-me .facility-name {
  flex-direction: column;
  align-items: flex-start !important;
}
.shared-with-me .facility-name h3 {
  margin-bottom: 0;
}
.shared-with-me .facility-name span {
  font-size: min(0.9rem, 22px);
  color: #58585F;
  font-family: "Roboto-Regular";
}

.modal-header {
  min-height: 58px;
  padding: 16px 30px;
  position: relative;
  display: flex;
  align-items: center;
}
.modal-header .close-block {
  padding: 0 !important;
  text-align: left;
  margin-left: -5px;
}
.modal-header .close-block .back-btn {
  position: initial !important;
}
.modal-header .line-wrapper {
  width: 36px;
  height: 58px;
  border-radius: 2.5px;
  opacity: 0.5;
  position: absolute;
  left: 50%;
  z-index: 1000;
  transform: translate(-50%, -8px);
}
.modal-header .line-wrapper .line {
  width: 36px;
  height: 5px;
  border-radius: 2.5px;
  opacity: 0.5;
  background-color: #A7A7AE;
  position: absolute;
  top: 5px;
}

.modal-content {
  border: none;
  border-top: 1px solid #dee2e5;
  margin-bottom: 18px;
  height: fit-content;
}
.modal-content .facility {
  border-bottom: 1px solid #dee2e5;
  margin: 0 30px;
  padding: 16px 0;
  min-height: 43px;
}
.modal-content .facility.subscription {
  height: auto !important;
}
.modal-content .facility .row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  height: 100%;
  align-items: center;
}
.modal-content .facility .facility-name {
  flex-direction: column !important;
}
.modal-content .facility .facility-name h3 {
  font-weight: 500;
  line-height: min(1.4rem, 30px);
  width: 100%;
  color: var(--vl-black);
  margin: 0;
}
.modal-content .facility .facility-name vl-icon {
  padding-left: 9px;
}
.modal-content .facility .facility-name vl-icon ::ng-deep svg {
  stroke: #A7A7AE;
  fill: #A7A7AE;
}
.modal-content .facility .facility-name .status-icon {
  padding: 0;
  padding-left: 3px;
}
.modal-content .facility .statuses {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
}
.modal-content .facility .statuses vl-icon path {
  stroke: green;
}
.modal-content .facility .statuses ion-badge {
  padding: 10px;
  font-size: min(0.75rem, 18px);
  font-weight: 700;
  border-radius: 30px;
  font-family: "Roboto-Regular";
  height: 23px;
  line-height: min(1.4rem, 30px);
  box-sizing: border-box;
  display: flex;
  align-items: center;
}
.modal-content .facility .statuses ion-badge.AVAILABLE {
  --color: var(--vl-green);
  --background: var(--vl-green-light);
}
.modal-content .facility .statuses ion-badge.OCCUPIED {
  --color: white;
  --background: var(--vl-red);
}
.modal-content .facility .statuses ion-badge.OUT_OF_ORDER {
  --color: white;
  --background: #A7A7AE;
}
.modal-content .facility .statuses .subscription {
  font-weight: 400;
  font-size: min(0.75rem, 18px);
  line-height: min(0.9rem, 20px);
  color: #00588F;
  padding-top: 5px;
}
.modal-content .facility .rates .rate {
  font-size: min(1.2rem, 22px);
  line-height: min(1.4rem, 30px);
  font-weight: 300;
  text-align: right;
  font-family: "Roboto-Light";
}
.modal-content .facility .rates .rate .red {
  font-weight: 700;
  color: var(--vl-red);
  font-family: "Roboto-Bold";
  font-size: min(1.2rem, 22px);
}
.modal-content .facility .rates .rate .divider {
  padding-right: 3px;
  padding-left: 3px;
}
.modal-content .facility .rates .minimum {
  margin-top: 5px;
  font-size: min(0.75rem, 18px);
  line-height: min(1rem, 24px);
  text-align: right;
  font-weight: 400;
  font-family: "Roboto-Regular";
}
.modal-content .information {
  min-height: 132px;
  font-family: "Roboto-Regular";
  font-weight: 400;
  font-size: min(0.75rem, 18px);
  line-height: min(0.9rem, 20px);
  padding: 16px 30px !important;
}
.modal-content .information.orders {
  border-top: 1px solid #dee2e5;
  padding-left: 0;
  padding-right: 0;
  margin: 0 16px;
  min-height: 0;
}
.modal-content .information .row {
  margin-bottom: 6px;
}
.modal-content .information .row .col-8 {
  display: flex;
  align-items: flex-start;
}
.modal-content .information .row .key {
  color: #58585f;
  font-weight: 400;
  font-size: min(0.75rem, 18px);
}
.modal-content .information .row .not-renew {
  font-family: "Roboto-Regular";
  line-height: min(1rem, 24px);
  font-size: min(0.75rem, 18px);
  color: #58585f;
  font-weight: 400;
}
.modal-content .information .row .address {
  color: var(--vl-red);
  text-decoration: underline;
}
.modal-content .information.subscription .row {
  display: flex;
  justify-content: space-between;
}
.modal-content .information.subscription .row.divider {
  padding-bottom: 16px;
  border-bottom: 1px solid #dee2e5;
  margin-bottom: 16px;
}
.modal-content .information.subscription .row .item {
  display: flex;
  flex-direction: column;
}
.modal-content .information.subscription .row .item .text {
  font-family: "Roboto-Regular";
  font-size: min(0.75rem, 18px);
  font-weight: 400;
  color: var(--vl-black-font);
  line-height: min(1rem, 24px);
  padding: 0 5px;
  padding-bottom: 3px;
}
.modal-content .information.subscription .row .item .value {
  font-family: "Roboto-Medium";
  font-size: min(0.9rem, 22px);
  font-weight: 500;
  color: var(--vl-black);
  line-height: min(1rem, 24px);
  padding: 5px;
}
.modal-content .information.subscription .row .item.from {
  width: fit-content;
  padding-left: 0;
  width: 31%;
}
.modal-content .information.subscription .row .item.from .arrow-icons-up {
  position: absolute;
  left: 28%;
  top: 35%;
  font-size: 16px;
  color: var(--vl-black-font);
  opacity: 0.8;
}
.modal-content .information.subscription .row .item.from .arrow-icons-down {
  position: absolute;
  left: 28%;
  top: 39%;
  font-size: 16px;
  color: var(--vl-black-font);
  opacity: 0.8;
}
.modal-content .information.subscription .row .item.to {
  width: fit-content;
  width: 32%;
  padding-right: 0;
}
.modal-content .information.subscription .row .item.duration {
  align-items: center;
  padding: 0 8px;
  width: fit-content;
  padding-right: 0;
}
.modal-content .information.subscription .row .item.divider {
  border-right: 1px solid #EDEEF3;
  width: 1px;
  padding: 0;
}

.row {
  margin: 0;
}

.back-btn {
  border-radius: 0 !important;
  color: var(--vl-black-font);
  height: 26px;
  font-size: min(1.1rem, 26px);
  line-height: min(1.4rem, 30px);
  font-family: "Roboto-Regular";
  margin-left: 0 !important;
  padding-left: 0 !important;
}
.back-btn ion-icon {
  min-width: 20px;
}

.custom-btn-block {
  align-items: center;
  justify-content: center;
}
.custom-btn-block .book-without-sub {
  font-size: min(0.75rem, 18px);
  line-height: min(1rem, 24px);
  color: var(--vl-black-font);
  text-decoration: underline;
  height: 20px;
  font-family: "Roboto-Regular";
}
.custom-btn-block ion-button {
  margin-left: 0;
}
.custom-btn-block .col-12 {
  max-width: 380px;
}
.custom-btn-block.alone {
  display: flex;
  align-items: flex-end;
}

.back-btn {
  margin-top: 0 !important;
}

.package-icon {
  position: absolute;
  right: 16px;
  bottom: 16px;
  top: 16px;
}
.package-icon ::ng-deep svg {
  stroke: darkgrey !important;
}

.show-hide-button {
  font-size: min(0.75rem, 18px);
  line-height: min(1rem, 24px);
  color: #212529;
  text-decoration: underline;
  display: flex;
  justify-content: flex-end;
  margin-bottom: 16px;
}

.show-more .expandable-area {
  overflow-y: scroll;
  max-height: 100px;
  -ms-overflow-style: none; /* IE и Edge */
  scrollbar-width: none; /* Firefox */
}
.show-more .expandable-area.share-order {
  max-height: 15vh;
}
.show-more .expandable-area::-webkit-scrollbar {
  width: 0;
}

.routing-wrapper {
  align-items: center;
}
.routing-wrapper .routing-icons span ion-icon {
  padding-right: 10px;
  width: 24px;
  height: 24px;
  color: #58585f;
}

.tower-img-wrapper {
  padding: 16px 30px 0;
}
.tower-img-wrapper img {
  border-radius: 20px;
  width: 100%;
}

.close-wrapper {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.close-wrapper .icons-container {
  display: flex;
  align-items: center;
}
.close-wrapper vl-icon {
  color: #A7A7AE;
}
.close-wrapper vl-icon.pinpad {
  margin-right: 16px;
  border: 1px solid;
  padding: 2px;
  border-radius: 5px;
}
.close-wrapper vl-icon.padding-left {
  padding-left: 15px;
}

.change-start-date {
  font-family: "Roboto-Regular";
  line-height: min(1rem, 24px);
  font-size: min(0.75rem, 18px);
  color: #58585f;
  font-weight: 400;
  padding-top: 10px;
  display: flex;
  align-items: center;
  color: darkorange;
}
.change-start-date.active-subscription {
  color: var(--vl-green);
  padding-top: 5px;
}
.change-start-date.active-subscription ion-icon {
  padding-right: 8px;
  font-size: 16px;
}
.change-start-date .warning-icon {
  font-size: 20px;
  padding-right: 8px;
}

.from-border {
  border: 1px #dee2e5 solid;
  background: white;
  border-radius: 10px;
}

ion-skeleton-text {
  --background: rgba(0, 0, 0, 0.7);
  --background-rgb: 0, 0, 0;
}

.inner-content .modal-content .sub-details {
  font-family: "Roboto-Regular";
  font-weight: 400;
  padding: 0 !important;
  min-height: auto !important;
}
.inner-content .modal-content .sub-details .show-hide-button {
  margin: 16px 0 0;
}
.inner-content .modal-content .sub-details .from-border {
  padding: 5px 10px;
  margin-top: 10px;
}
.inner-content .modal-content .sub-details .row .change-start-date {
  padding: 7px 0 !important;
}`, "",{"version":3,"sources":["webpack://./src/app/modules/bookings/booking-steps/booking-steps.component.scss","webpack://./src/assets/scss/_vl-variables.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACgBhB;EACE,4BAXc;ADHhB;;ACkBA;EACE,kBAZe;EAaf,mBAbe;ADFjB;;ACkBA;EACE,iBAjBe;EAkBf,oBAlBe;ADGjB;;ACkBA;EACE,aAtBe;ADOjB;;ACkBA;EACE,8BAAA;EACA,mCAAA;ADfF;;ACkBA;EACE,6BAAA;EACA,qCAAA;ADfF;;ACkBA;EACE,oBAAA;ADfF;;ACkBA;EACE,iBAAA;EACA,mBAAA;ADfF;;ACkBA;EACE,oBAAA;ADfF;;ACkBA;EACE,qBAAA;ADfF;;ACkBA;EACE,mBAAA;EACA,aAAA;ADfF;;ACkBA;EACE,cAAA;EACA,uBAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;ADfF;;AAvDE;EACE,aAAA;EACA,mBAAA;AA0DJ;;AAtDA;EACE,4BAAA;EACA,gBAAA;AAyDF;;AAtDA;EACE,qBAAA;EACA,2BAAA;AAyDF;;AArDE;EACE,mBAAA;AAwDJ;AAvDI;EACE,mBAAA;AAyDN;AApDE;EACE,sBAAA;EACA,kCAAA;AAsDJ;AApDI;EACE,gBAAA;AAsDN;AAnDI;EACE,4BAAA;EACA,cAAA;EACA,6BC/BW;ADoFjB;;AAhDA;EACE,gBAAA;EAEA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;AAkDF;AA/CE;EACE,qBAAA;EACA,gBAAA;EACA,iBAAA;AAiDJ;AAhDI;EACE,4BAAA;AAkDN;AA7CE;EACE,WAAA;EACA,YAAA;EACA,oBAAA;EACA,YAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,gCAAA;AA+CJ;AA7CI;EACE,WAAA;EACA,WAAA;EACA,oBAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,QAAA;AA+CN;;AAxCA;EACE,YAAA;EACA,6BAAA;EACA,mBAAA;EACA,mBAAA;AA2CF;AA1CE;EACE,gCAAA;EAEA,cAAA;EACA,eAAA;EACA,gBAAA;AA2CJ;AA1CI;EACE,uBAAA;AA4CN;AAzCI;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,YAAA;EACA,mBAAA;AA2CN;AAvCI;EAEE,iCAAA;AAwCN;AArCM;EACE,gBAAA;EACA,8BAAA;EAEA,WAAA;EACA,sBAAA;EACA,SAAA;AAsCR;AAnCM;EACE,iBAAA;AAqCR;AAnCQ;EACE,eAAA;EACA,aAAA;AAqCV;AAlCM;EACE,UAAA;EAEA,iBAAA;AAmCR;AA/BI;EACE,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,uBAAA;EACA,WAAA;AAiCN;AA9BQ;EACE,aAAA;AAgCV;AA5BM;EACE,aAAA;EACA,6BAAA;EACA,gBAAA;EACA,mBAAA;EACA,6BCtJS;EDuJT,YAAA;EACA,8BAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;AA8BR;AA5BQ;EACE,wBAAA;EACA,mCAAA;AA8BV;AA3BQ;EACE,cAAA;EACA,2BAAA;AA6BV;AA1BQ;EACE,cAAA;EACA,qBAAA;AA4BV;AAxBM;EACE,gBAAA;EACA,6BAAA;EACA,8BAAA;EACA,cAAA;EACA,gBAAA;AA0BR;AArBM;EACE,4BAAA;EACA,8BAAA;EACA,gBAAA;EACA,iBAAA;EACA,2BC7LO;ADoNf;AArBQ;EACE,gBAAA;EACA,oBAAA;EACA,0BCpMI;EDqMJ,4BAAA;AAuBV;AApBQ;EACE,kBAAA;EACA,iBAAA;AAsBV;AAlBM;EACE,eAAA;EACA,6BAAA;EACA,4BAAA;EACA,iBAAA;EACA,gBAAA;EACA,6BCjNS;ADqOjB;AAfE;EAEE,iBAAA;EACA,6BCzNa;ED0Nb,gBAAA;EACA,6BAAA;EACA,8BAAA;EACA,6BAAA;AAgBJ;AAdI;EACE,6BAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,aAAA;AAgBN;AAbI;EACE,kBAAA;AAeN;AAbM;EACE,aAAA;EACA,uBAAA;AAeR;AAZM;EACE,cAAA;EACA,gBAAA;EACA,6BAAA;AAcR;AAXM;EACE,6BCtPS;EDuPT,4BAAA;EACA,6BAAA;EACA,cAAA;EACA,gBAAA;AAaR;AAVM;EACE,oBAAA;EACA,0BAAA;AAYR;AAHM;EACE,aAAA;EACA,8BAAA;AAKR;AAHQ;EACE,oBAAA;EACA,gCAAA;EACA,mBAAA;AAKV;AAFQ;EACE,aAAA;EACA,sBAAA;AAIV;AAFU;EACE,6BCvRK;EDwRL,6BAAA;EACA,gBAAA;EACA,2BAAA;EACA,4BAAA;EACA,cAAA;EACA,mBAAA;AAIZ;AADU;EACE,4BCnSI;EDoSJ,4BAAA;EACA,gBAAA;EACA,sBAAA;EACA,4BAAA;EACA,YAAA;AAGZ;AAAU;EACE,kBAAA;EACA,eAAA;EACA,UAAA;AAEZ;AADY;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,eAAA;EACA,2BAAA;EACA,YAAA;AAGd;AADY;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,eAAA;EACA,2BAAA;EACA,YAAA;AAGd;AACU;EAEE,kBAAA;EACA,UAAA;EACA,gBAAA;AAAZ;AAGU;EACE,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;AADZ;AAIU;EACE,+BAAA;EACA,UAAA;EACA,UAAA;AAFZ;;AAUA;EACE,SAAA;AAPF;;AAUA;EACE,2BAAA;EACA,2BAAA;EACA,YAAA;EACA,4BAAA;EACA,8BAAA;EACA,6BClWe;EDmWf,yBAAA;EACA,0BAAA;AAPF;AASE;EACE,eAAA;AAPJ;;AAWA;EAEE,mBAAA;EACA,uBAAA;AATF;AAUE;EACE,6BAAA;EACA,4BAAA;EACA,2BAAA;EACA,0BAAA;EACA,YAAA;EACA,6BCrXa;AD6WjB;AAUE;EACE,cAAA;AARJ;AAUE;EACE,gBAAA;AARJ;AAUE;EACE,aAAA;EACA,qBAAA;AARJ;;AAYA;EACE,wBAAA;AATF;;AAYA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;AATF;AAUE;EACE,2BAAA;AARJ;;AAYA;EACE,6BAAA;EACA,4BAAA;EACA,cAAA;EACA,0BAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;AATF;;AAcE;EACE,kBAAA;EACA,iBAAA;EACA,wBAAA,EAAA,cAAA;EACA,qBAAA,EAAA,YAAA;AAXJ;AAYI;EACE,gBAAA;AAVN;AAaE;EACE,QAAA;AAXJ;;AAiBA;EACE,mBAAA;AAdF;AAeE;EACE,mBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;AAbJ;;AAiBA;EACE,oBAAA;AAdF;AAeE;EACE,mBAAA;EACA,WAAA;AAbJ;;AAiBA;EACE,WAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AAdF;AAeE;EACE,aAAA;EACA,mBAAA;AAbJ;AAeE;EAOE,cAAA;AAnBJ;AAaI;EACE,kBAAA;EACA,iBAAA;EACA,YAAA;EACA,kBAAA;AAXN;AAcI;EACE,kBAAA;AAZN;;AAiBA;EASE,6BAAA;EACA,4BAAA;EACA,6BAAA;EACA,cAAA;EACA,gBAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;AAtBF;AAME;EACE,sBAAA;EACA,gBAAA;AAJJ;AAKI;EACE,kBAAA;EACA,eAAA;AAHN;AAeE;EACE,eAAA;EACA,kBAAA;AAbJ;;AAkBA;EACE,yBAAA;EACA,iBAAA;EACA,mBAAA;AAfF;;AAkBA;EACE,gCAAA;EACA,yBAAA;AAfF;;AAmBE;EACE,6BC5fa;ED6fb,gBAAA;EACA,qBAAA;EACA,2BAAA;AAhBJ;AAiBI;EACE,gBAAA;AAfN;AAiBI;EACE,iBAAA;EACA,gBAAA;AAfN;AAkBM;EACE,yBAAA;AAhBR","sourcesContent":["@use \"/src/assets/scss/vl-variables\" as *;\n\n.additional-space {\n  ::ng-deep.sc-ion-modal-md-h, ::ng-deep.sc-ion-modal-ios-h {\n    --height: 60%;\n    --min-height: 470px;\n  }\n}\n\n::ng-deep ion-modal.auto-height .modal-wrapper {\n  background: white !important;\n  max-height: 95vh;\n}\n\n.inner-content {\n  padding: 0 !important;\n  max-height: 90vh !important;\n}\n\n.shared-with-me {\n  &.show-bg {\n    background: #FCFEE9;\n    .modal-header, .modal-content {\n      background: #FCFEE9;\n    }\n\n  }\n\n  .facility-name {\n    flex-direction: column;\n    align-items: flex-start !important;\n\n    h3 {\n      margin-bottom: 0;\n    }\n\n    span {\n      font-size: min(0.9rem, 22px);\n      color: #58585F;\n      font-family: $roboto-regular;\n    }\n  }\n}\n\n.modal-header {\n  min-height: 58px;\n  //padding-left: 10px !important;\n  padding:16px 30px;\n  position: relative;\n  display: flex;\n  align-items: center;\n\n\n  .close-block {\n    padding: 0 !important;\n    text-align: left;\n    margin-left: -5px;\n    .back-btn {\n      position: initial !important;\n    }\n  }\n\n\n  .line-wrapper {\n    width: 36px;\n    height: 58px;\n    border-radius: 2.5px;\n    opacity: 0.5;\n    position: absolute;\n    left: 50%;\n    z-index: 1000;\n    transform: translate(-50%, -8px);\n\n    .line {\n      width: 36px;\n      height: 5px;\n      border-radius: 2.5px;\n      opacity: .5;\n      background-color: #A7A7AE;\n      position: absolute;\n      top: 5px;\n      //left: 50%;\n      //transform: translate(-50%, 50%);\n    }\n  }\n}\n\n.modal-content {\n  border: none;\n  border-top: 1px solid #dee2e5;\n  margin-bottom: 18px;\n  height: fit-content;\n  .facility {\n    border-bottom: 1px solid #dee2e5;\n    // border-top: 1px solid #dee2e5;\n    margin: 0 30px;\n    padding: 16px 0;\n    min-height: 43px;\n    &.subscription {\n      height: auto !important;\n    }\n\n    .row {\n      display: flex;\n      align-items: flex-start;\n      justify-content: space-between;\n      height: 100%;\n      align-items: center;\n    }\n\n\n    .facility-name {\n      @extend .d-f-a-c;\n      flex-direction: column !important;\n      // min-height: 30px;\n\n      h3 {\n        font-weight: 500;\n        line-height: min(1.4rem, 30px);\n        //max-width: 80%;\n        width: 100%;\n        color: var(--vl-black);\n        margin: 0;\n      }\n\n      vl-icon {\n        padding-left: 9px;\n\n        ::ng-deep svg {\n          stroke: #A7A7AE;\n          fill: #A7A7AE\n        }\n      }\n      .status-icon {\n        padding: 0;\n        // position: absolute;\n        padding-left: 3px;\n      }\n    }\n\n    .statuses {\n      display: flex;\n      flex-direction: column;\n      justify-content: flex-start;\n      align-items: flex-start;\n      width: 100%;\n\n      vl-icon {\n        path {\n          stroke: green;\n        }\n      }\n\n      ion-badge {\n        padding: 10px;\n        font-size: min(0.75rem, 18px);\n        font-weight: 700;\n        border-radius: 30px;\n        font-family: $roboto-regular;\n        height: 23px;\n        line-height: min(1.4rem, 30px);\n        box-sizing: border-box;\n        display: flex;\n        align-items: center;\n\n        &.AVAILABLE {\n          --color: var(--vl-green);\n          --background: var(--vl-green-light);\n        }\n\n        &.OCCUPIED {\n          --color: white;\n          --background: var(--vl-red);\n        }\n\n        &.OUT_OF_ORDER {\n          --color: white;\n          --background: #A7A7AE;\n        }\n      }\n\n      .subscription {\n        font-weight: 400;\n        font-size: min(0.75rem, 18px);\n        line-height: min(0.9rem, 20px);\n        color: #00588F;\n        padding-top: 5px;\n      }\n    }\n\n    .rates {\n      .rate {\n        font-size: min(1.2rem, 22px);\n        line-height: min(1.4rem, 30px);\n        font-weight: 300;\n        text-align: right;\n        font-family: $roboto-light;\n\n        .red {\n          font-weight: 700;\n          color: var(--vl-red);\n          font-family: $roboto-bold;\n          font-size: min(1.2rem, 22px);\n        }\n\n        .divider {\n          padding-right: 3px;\n          padding-left: 3px;\n        }\n      }\n\n      .minimum {\n        margin-top: 5px;\n        font-size: min(0.75rem, 18px);\n        line-height: min(1rem, 24px);\n        text-align: right;\n        font-weight: 400;\n        font-family: $roboto-regular;\n      }\n    }\n  }\n\n  .information {\n    @extend .p-16px;\n    min-height: 132px;\n    font-family: $roboto-regular;\n    font-weight: 400;\n    font-size: min(0.75rem, 18px);\n    line-height: min(0.9rem, 20px);\n    padding: 16px 30px !important;\n\n    &.orders {\n      border-top: 1px solid #dee2e5;\n      padding-left: 0;\n      padding-right: 0;\n      margin: 0 16px;\n      min-height: 0;\n    }\n\n    .row {\n      margin-bottom: 6px;\n\n      .col-8 {\n        display: flex;\n        align-items: flex-start;\n      }\n\n      .key {\n        color: #58585f;\n        font-weight: 400;\n        font-size: min(0.75rem, 18px);\n      }\n\n      .not-renew {\n        font-family: $roboto-regular;\n        line-height: min(1rem, 24px);\n        font-size: min(0.75rem, 18px);\n        color: #58585f;\n        font-weight: 400;\n      }\n\n      .address {\n        color: var(--vl-red);\n        text-decoration: underline;\n        //white-space: nowrap;\n        //overflow: hidden;\n\n      }\n    }\n\n    &.subscription {\n\n      .row {\n        display: flex;\n        justify-content: space-between;\n\n        &.divider {\n          padding-bottom: 16px;\n          border-bottom: 1px solid #dee2e5;\n          margin-bottom: 16px;\n        }\n\n        .item {\n          display: flex;\n          flex-direction: column;\n\n          .text {\n            font-family: $roboto-regular;\n            font-size: min(0.75rem, 18px);\n            font-weight: 400;\n            color: var(--vl-black-font);\n            line-height: min(1rem, 24px);\n            padding: 0 5px;\n            padding-bottom: 3px;\n          }\n\n          .value {\n            font-family: $roboto-medium;\n            font-size: min(0.9rem, 22px);\n            font-weight: 500;\n            color: var(--vl-black);\n            line-height: min(1rem, 24px);\n            padding: 5px;\n          }\n\n          &.from {\n            width: fit-content;\n            padding-left: 0;\n            width: 31%;\n            .arrow-icons-up {\n              position: absolute;\n              left: 28%;\n              top: 35%;\n              font-size: 16px;\n              color: var(--vl-black-font);\n              opacity: 0.8;\n            }\n            .arrow-icons-down {\n              position: absolute;\n              left: 28%;\n              top: 39%;\n              font-size: 16px;\n              color: var(--vl-black-font);\n              opacity: 0.8;\n            }\n          }\n\n          &.to {\n            // padding: 0 15px;\n            width: fit-content;\n            width: 32%;\n            padding-right: 0;\n          }\n\n          &.duration {\n            align-items: center;\n            padding: 0 8px;\n            width: fit-content;\n            padding-right: 0;\n          }\n\n          &.divider {\n            border-right: 1px solid #EDEEF3;\n            width: 1px;\n            padding: 0;\n          }\n        }\n      }\n    }\n  }\n}\n\n.row {\n  margin: 0;\n}\n\n.back-btn {\n  border-radius: 0 !important;\n  color: var(--vl-black-font);\n  height: 26px;\n  font-size: min(1.1rem, 26px);\n  line-height: min(1.4rem, 30px);\n  font-family: $roboto-regular;\n  margin-left: 0 !important;\n  padding-left: 0 !important;\n\n  ion-icon {\n    min-width: 20px;\n  }\n}\n\n.custom-btn-block {\n  // min-height: 106px;\n  align-items: center;\n  justify-content: center;\n  .book-without-sub {\n    font-size: min(0.75rem, 18px);\n    line-height: min(1rem, 24px);\n    color: var(--vl-black-font);\n    text-decoration: underline;\n    height: 20px;\n    font-family: $roboto-regular;\n  }\n  ion-button {\n    margin-left: 0;\n  }\n  .col-12 {\n    max-width: 380px;\n  }\n  &.alone {\n    display: flex;\n    align-items: flex-end;\n  }\n}\n\n.back-btn {\n  margin-top: 0 !important;\n}\n\n.package-icon {\n  position: absolute;\n  right: 16px;\n  bottom: 16px;\n  top: 16px;\n  ::ng-deep svg {\n    stroke: darkgrey !important;\n  }\n}\n\n.show-hide-button {\n  font-size: min(0.75rem, 18px);\n  line-height: min(1rem, 24px);\n  color: #212529;\n  text-decoration: underline;\n  display: flex;\n  justify-content: flex-end;\n  margin-bottom: 16px;\n}\n.show-more {\n  // margin-bottom: 16px;\n\n  .expandable-area {\n    overflow-y: scroll;\n    max-height: 100px;\n    -ms-overflow-style: none;  /* IE и Edge */\n    scrollbar-width: none;  /* Firefox */\n    &.share-order {\n      max-height: 15vh;\n    }\n  }\n  .expandable-area::-webkit-scrollbar {\n    width: 0;\n  }\n\n\n}\n\n.routing-wrapper {\n  align-items: center;\n  .routing-icons span ion-icon {\n    padding-right: 10px;\n    width: 24px;\n    height: 24px;\n    color: #58585f;\n  }\n}\n\n.tower-img-wrapper {\n  padding: 16px 30px 0;\n  img {\n    border-radius: 20px;\n    width: 100%;\n  }\n}\n\n.close-wrapper {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  .icons-container {\n    display: flex;\n    align-items: center;\n  }\n  vl-icon {\n    &.pinpad {\n      margin-right: 16px;\n      border: 1px solid;\n      padding: 2px;\n      border-radius: 5px;\n    }\n    color: #A7A7AE;\n    &.padding-left {\n      padding-left: 15px;\n    }\n  }\n}\n\n.change-start-date {\n  &.active-subscription {\n    color: var(--vl-green);\n    padding-top: 5px;\n    ion-icon {\n      padding-right: 8px;\n      font-size: 16px;\n    }\n  }\n  font-family: \"Roboto-Regular\";\n  line-height: min(1rem, 24px);\n  font-size: min(0.75rem, 18px);\n  color: #58585f;\n  font-weight: 400;\n  padding-top: 10px;\n  display: flex;\n  align-items: center;\n  color: darkorange;\n  .warning-icon {\n    font-size: 20px;\n    padding-right: 8px;\n  }\n}\n\n\n.from-border {\n  border: 1px #dee2e5 solid;\n  background: white;\n  border-radius: 10px;\n}\n\nion-skeleton-text {\n  --background: rgba(0, 0, 0, 0.7);\n  --background-rgb: 0, 0, 0;\n}\n\n.inner-content .modal-content {\n  .sub-details {\n    font-family: $roboto-regular;\n    font-weight: 400;\n    padding: 0!important;\n    min-height: auto !important;\n    .show-hide-button {\n      margin: 16px 0 0;\n    }\n    .from-border {\n      padding: 5px 10px;\n      margin-top: 10px;\n    }\n    .row {\n      .change-start-date {\n        padding: 7px 0 !important;\n      }\n    }\n  }\n}","$red: #EB0000;\n$black: #262627;\n\n$font-path: \"~roboto-fontface/fonts/roboto/\";\n$font-format: 'woff';\n$roboto-bold: \"Roboto-Bold\";\n$roboto-medium: \"Roboto-Medium\";\n$roboto-light: \"Roboto-Light\";\n$roboto-regular: \"Roboto-Regular\";\n\n$global-padding: 16px;\n$global-padding-with-fixed-button: 108px;\n$toolbar-height: 70px;\n$modal-height: 425px;\n$edit-phone-email-modal-height: 325px;\n\nion-button {\n  font-family: $roboto-medium;\n}\n\n\n.px-16px {\n  padding-left: $global-padding;\n  padding-right: $global-padding;\n}\n\n.py-16px {\n  padding-top: $global-padding;\n  padding-bottom: $global-padding;\n}\n\n.p-16px {\n  padding: $global-padding;\n}\n\n.pr-16px {\n  padding-right: $global-padding !important;\n  padding-inline-end: $global-padding !important;\n}\n\n.pl-16px {\n  padding-left: $global-padding !important;\n  padding-inline-start: $global-padding !important;\n}\n\n.pb-16px {\n  padding-bottom: 16px;\n}\n\n.pt-16px {\n  padding-top: 16px;\n  --padding-top: 16px;\n}\n\n.m-0 {\n  margin: 0 !important;\n}\n\n.p-0 {\n  padding: 0 !important;\n}\n\n.d-f-a-c {\n  align-items: center;\n  display: flex;\n}\n\n.three-dots {\n  display: block;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  width: 100%;\n  height: 100%;\n  white-space: nowrap;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
